import { priceFormatter } from '@noths/polaris-client-utils';
import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { FREE_DELIVERY } from 'src/components/organisms/DeliverySection/constants/copy';

export const getFormattedPrice = (amount: number, currencyCode: CurrencyCode) => {
  return amount === 0 ? FREE_DELIVERY : priceFormatter(currencyCode, amount, false);
};
